import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

const SectionContainer = styled('div')`
  margin: ${themeVars.medium} ${themeVars.big};
  ${props => (props.help ? 'font-style: italic;' : '')} 
  ${props => (props.help ? `color: ${themeVars.dark};` : '')} 
  ${props => (props.help ? `font-size: 12px;` : '')} 
`

const Label = styled('div')`
  margin-bottom: ${themeVars.mini};
`

const Section = ({ children, label, help }) => (
  <SectionContainer help={help}>
    {label && <Label>{label}</Label>}
    {children}
  </SectionContainer>
)

export default Section
